const originalURL = globalThis.URL;

globalThis.URL = class URL extends originalURL {
	constructor(url: string | URL, base?: string | URL) {
		let finalUrl: string | URL = url;

		if (typeof url === 'string' && url.startsWith('blob:')) {
			finalUrl = url;
		}

		super(finalUrl as string, base as string);
	}

	static parse(url: string, base?: string): URL | null {
		try {
			return new URL(url, base);
		} catch {
			return null;
		}
	}
} as typeof originalURL;
